import { c as _c } from "react/compiler-runtime";
import { Faq } from "@website/widget/faq";
import { Header } from "@website/widget/header";
import type { NextPage } from "next";
import Head from "next/head";
import backfold from "../../public/assets/backfold.png";
import large from "../../public/assets/large.png";
import small from "../../public/assets/small.png";
import support from "../../public/assets/support.png";
import { VillaHostCityCarousel } from "./components/VillaHostCityCarousel";
import { VillaHostExperienceCarousel } from "./components/VillaHostExperienceCarousel";
import { VillaHostFeatureFocusScroller } from "./components/VillaHostFeatureFocusScroller";
import { VillaHostInfoCards } from "./components/VillaHostInfoCards";
import { VillaHostJoinBanner } from "./components/VillaHostJoinBanner";
import { VillaHostSignupButton } from "./components/VillaHostSignupButton";
import { VillaHostStepSection } from "./components/VillaHostStepSection";
import { VillaHostStickyCTA } from "./components/VillaHostStickyCTA";
import { VillaHostSupportCard } from "./components/VillaHostSupportCard";
import { cities, faqs, features, infoItems, steps, testimonials } from "./page.data";
const VillaHostPage: NextPage = () => {
  const $ = _c(16);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Head><meta content="noindex,nofollow" name="robots" /></Head>;
    t1 = <Header title={"\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      background: "linear-gradient(358.04deg, #FFFFFF 84.21%, #F8F9FD 112.83%, #FFFFFF 120.26%), linear-gradient(0deg, #FFFFFF, #FFFFFF), rgba(255, 255, 255, 0.2)"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-base max-lg:text-center lg:text-xl">سرویس میزبانی اقامتگاه در{" "}<span className="text-on-surface-secondary-high-emphasis font-bold">اسنپ تریپ</span></p>;
    t4 = <div className="pt-5 text-2xl font-extrabold max-lg:pb-4 lg:text-4xl">تجربه‌ای هوشمند و پر درآمد{" "}</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-2 py-6 max-lg:hidden lg:pb-7 lg:pt-12"><VillaHostSignupButton className="w-1/2" size="large" /><span className="text-on-surface-high-emphasis text-xs">دیده شوید، رزرو بگیرید، درآمد کسب کنید</span></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="lg:w-1/2 lg:pt-4">{t3}{t4}{t5}<div className="w-full max-lg:hidden"><VillaHostInfoCards items={infoItems} /></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div aria-hidden={true} className="pointer-events-none absolute -inset-10 bg-contain bg-center bg-no-repeat opacity-40 lg:-inset-16" style={{
      backgroundImage: `url(${backfold.src})`
    }} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="relative w-full overflow-visible lg:w-1/2 lg:p-8">{t7}<div className="relative z-10"><VillaHostFeatureFocusScroller features={features} /></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="w-full lg:hidden"><VillaHostStickyCTA /></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <section className="flex items-center px-6 pb-6 pt-5 max-lg:flex-col lg:pb-12 xl:mx-auto xl:max-w-[1200px] xl:px-0">{t6}{t8}{t9}<div className="lg:hidden"><VillaHostInfoCards items={infoItems} /></div></section>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <section className="w-full pb-6 lg:py-2 lg:pb-12 xl:mx-auto xl:max-w-[1200px] xl:px-0"><VillaHostStepSection steps={steps} /></section>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <section className="pb-6 lg:pb-12"><VillaHostExperienceCarousel testimonials={testimonials} /></section>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <section className="overflow-visible pb-6 max-lg:px-6 lg:pb-12 xl:mx-auto xl:max-w-[1200px] xl:px-0"><VillaHostJoinBanner smallImage={small.src} largeImage={large.src} /></section>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <section className="pb-6 lg:pb-12"><div className="py-11 pt-6 text-base font-bold max-lg:pr-6 lg:text-2xl xl:mx-auto xl:max-w-[1200px] xl:px-0">همراه شما در تمام شهرهای{" "}<span className="text-on-surface-secondary-high-emphasis">ایران</span></div><VillaHostCityCarousel cities={cities} /></section>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div>{t0}{t1}<main className="overflow-x-hidden" style={t2}>{t10}{t11}{t12}{t13}{t14}<section className="bg-dim-background mb-14 py-9 lg:mb-0 lg:pb-6"><div className="px-6 xl:mx-auto xl:max-w-[1200px] xl:px-0"><Faq list={faqs} title={"\u0633\u0648\u0627\u0644\u0627\u062A \u067E\u0631\u062A\u06A9\u0631\u0627\u0631"} /><VillaHostSupportCard image={support.src} /></div></section></main></div>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  return t15;
};
export default VillaHostPage;